var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"messages-card",class:_vm.message.type,attrs:{"title":_vm.message.user,"sub-title":_vm.dateTime}},[_c('b-card-text',[_vm._v(" "+_vm._s(_vm.message.content)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }